import SuperRepository from '../superRepository'

export default new (class EntityLogRepository extends SuperRepository {
  baseUri() {
    return 'entity_log'
  }
  exportEntityLogToken = (data, params) => this.reportHttpClient().postQuery('export/entity_log/token', data, params)
})()
